import OurProjectVerticalList from "../../our-project-vertical/List";
import { useCommercialDesignProjects } from "../../useHook";
import { SystemPermissions } from "../../../../Utils/permissionAccess";

function OurProjectCommercialDesignList() {
  return (
    <OurProjectVerticalList
      title="Manage Commercial Design Project"
      basePath="/our-project-commercial-design"
      sourceType="commercial_design_project"
      similarPermission={SystemPermissions.ManageCommercialDesignProject.ADD_SIMILAR}
      useProjectsHook={useCommercialDesignProjects}
    />
  );
}

export default OurProjectCommercialDesignList;
